module.exports = "/_next/static/media/ac7795945d7b1d3c79b94b29089052a9.svg";